import api from '../utils/api';

export interface AudioFileListRequest {
  limit?: number;
  pg?: number;
  name?: string;
}

export interface AudioFileResponse {
  id: number;
  name: string;
  originalFilename: string;
  audioDuration: number;
  filesize: number;
  createdAt: string;
}

export interface PageAudioFileResponse {
  content: AudioFileResponse[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export interface AudioFileUploadRequest {
  name: string;
  file: File;
}

export interface AudioFileUpdateRequest {
  name: string;
}

export const getAudioFileList = async (params: AudioFileListRequest) => {
  const response = await api.get<PageAudioFileResponse>('/audio-source', { params });
  return response.data;
};

export const getAudioFile = async (id: number) => {
  const response = await api.get<AudioFileResponse>(`/audio-source/${id}`);
  return response.data;
};

export const uploadAudioFile = async (data: AudioFileUploadRequest) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('file', data.file);
  
  const response = await api.post<AudioFileResponse>('/audio-source/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateAudioFile = async (id: number, data: AudioFileUpdateRequest) => {
  const response = await api.patch<AudioFileResponse>(`/audio-source/${id}`, data);
  return response.data;
};

export const deleteAudioFile = async (id: number) => {
  const response = await api.delete(`/audio-source/${id}`);
  return response.data;
};

export const downloadAudioFile = async (id: number) => {
  const response = await api.get(`/audio-source/file/${id}`, {
    responseType: 'blob',
  });
  return response.data;
};

export const downloadRecordFile = async (callId: number) => {
  const response = await api.get(`/audio-source/download/${callId}`, {
    responseType: 'blob',
  });
  return response.data;
};

export const downloadStereoRecordFile = async (callId: number) => {
  const response = await api.get(`/audio-source/download/${callId}/stereo`, {
    responseType: 'blob',
  });
  return response.data;
};
